import { render, staticRenderFns } from "./DropZoneV18Component.vue?vue&type=template&id=246b22ea&scoped=true"
import script from "./DropZoneV18Component.vue?vue&type=script&lang=js"
export * from "./DropZoneV18Component.vue?vue&type=script&lang=js"
import style0 from "./DropZoneV18Component.vue?vue&type=style&index=0&id=246b22ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246b22ea",
  null
  
)

export default component.exports